<div class="container-fluid py-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h4 class="mb-0">
      <i class="bi bi-geo-alt text-warning me-2"></i>{{ 'admin.locations.list_title' | translate }}
    </h4>
    <button class="btn btn-accent" (click)="addLocation()">
      <i class="bi bi-plus me-2"></i>{{ 'admin.locations.new_location' | translate }}
    </button>
  </div>

  <div class="card">
    <div class="card-body">
      <s-table [cols]="tabLocations.cols" [refreshUrl]="tabLocations.refreshUrl"
        [detailUrl]="tabLocations.detailUrl" [detailId]="tabLocations.detailId"
        [showPageSize]="!shared.isMobileConst">
      </s-table>
    </div>
  </div>
</div>
